var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        top: "5vh",
        width: "1200px",
        visible: _vm.visible,
        title: "代理模式设置",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("update:visible", false)
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            height: "70vh",
            "overflow-y": "auto",
            "overflow-x": "hidden",
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "返佣模式", prop: "back_model_type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.back_model_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "back_model_type", $$v)
                        },
                        expression: "form.back_model_type",
                      },
                    },
                    _vm._l(_vm.modeOptions, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.value,
                          attrs: {
                            label: item.value,
                            value: item.value,
                            disabled: item.disabled,
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    margin: "-22px 0 22px 140px",
                    width: "400px",
                    "background-color": "#f4f4f5",
                    color: "#909399",
                    padding: "10px",
                    "border-radius": "5px",
                  },
                },
                [
                  _c(
                    "ul",
                    {
                      staticStyle: {
                        "list-style": "none",
                        padding: "0",
                        margin: "0",
                      },
                    },
                    [
                      _c("li", [
                        _vm._v("全民代理返佣以用户"),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("有效投注"),
                        ]),
                        _vm._v("计算。"),
                      ]),
                      _c("li", [
                        _vm._v(
                          "直接下级贡献佣金：返佣比例为2%，有效投注为" +
                            _vm._s(_vm.amountUnit) +
                            "100，则贡献" +
                            _vm._s(_vm.amountUnit) +
                            "2"
                        ),
                      ]),
                      _c("li", [
                        _vm._v(
                          "二级代理贡献佣金：返佣比例为1%，有效投注为" +
                            _vm._s(_vm.amountUnit) +
                            "100，则贡献" +
                            _vm._s(_vm.amountUnit) +
                            "1"
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "代理计算层级", prop: "level_count" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.level_count,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "level_count", $$v)
                        },
                        expression: "form.level_count",
                      },
                    },
                    _vm._l(_vm.levelCountOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "rate-item" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "直属代理佣金比例",
                        prop: "share_one_rate",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          step: 0.01,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.form.share_one_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "share_one_rate", $$v)
                          },
                          expression: "form.share_one_rate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "suffix" }, [_vm._v("%")]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "rate-item" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "二级代理佣金比例",
                        prop: "share_two_rate",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          step: 0.01,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.form.share_two_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "share_two_rate", $$v)
                          },
                          expression: "form.share_two_rate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "suffix" }, [_vm._v("%")]),
                ],
                1
              ),
              _c("el-divider"),
              _c(
                "div",
                { staticClass: "time-range-item" },
                [
                  _c(
                    "div",
                    { staticClass: "time-range-item-radio" },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.radio,
                            callback: function ($$v) {
                              _vm.radio = $$v
                            },
                            expression: "radio",
                          },
                        },
                        [_vm._v("每天")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "佣金领取时间",
                        prop: "reward_time_range",
                      },
                    },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          "is-range": "",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          placeholder: "请选择时间范围",
                        },
                        model: {
                          value: _vm.form.reward_time_range,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "reward_time_range", $$v)
                          },
                          expression: "form.reward_time_range",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "rate-item" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "佣金打码倍数",
                        prop: "reward_lock_multiple",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          step: 0.01,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.form.reward_lock_multiple,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "reward_lock_multiple", $$v)
                          },
                          expression: "form.reward_lock_multiple",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "suffix" }, [_vm._v("倍")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "推广描述", prop: "share_desc" } },
                [
                  _c("Tinymce", {
                    key: _vm.tinymceKey,
                    attrs: { height: 260, language: "zh" },
                    model: {
                      value: _vm.form.share_desc,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "share_desc", $$v)
                      },
                      expression: "form.share_desc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("update:visible", false)
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }